module.exports = __webpack_public_path__ + "static/media/itch-io.5927d364.svg";